import { createBuriedTracker } from '~/utils/buried';

export default defineNuxtPlugin(() => {
  if (import.meta.server) return;

  const runtimeConfig = useRuntimeConfig();

  // 根据环境配置埋点
  const buriedConfig = {
    autoTrack: true,
    enableClick: true,
    enableExposure: true,
    enableScroll: runtimeConfig.public.env === 'production', // 生产环境启用滚动埋点
    exposureThreshold: 0.5,
    scrollThrottle: 200,
    customEvents: {},
  };

  // 创建并初始化埋点实例
  const tracker = createBuriedTracker(buriedConfig);
  tracker.init();

  // 提供埋点实例给应用使用
  return {
    provide: {
      buriedTracker: tracker,
    },
  };
});
